export enum EventActionType {
  edit = 'edit',
  view = 'view',
  delete = 'delete',
}
